(function(){
  var map=new WeakMap();
  function prep(v){
    v.muted=true;v.loop=true;v.playsInline=true;
    v.setAttribute('muted','');v.setAttribute('playsinline','');v.setAttribute('autoplay','');
    var p=v.play();if(p&&p.catch){p.catch(function(){});}
  }
  var io=null;
  if('IntersectionObserver' in window){
    io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var el=map.get(e.target)||e.target;
        if(el.tagName==='VIDEO'){
          if(e.isIntersecting){prep(el);}else{el.pause();}
        }else if(e.isIntersecting&&typeof el.loadContent==='function'&&!el.getAttribute('loaded')){
          el.loadContent(false);
        }
      });
    },{threshold:0.4});
  }
  function watch(target,el){
    map.set(target,el);
    if(io){io.observe(target);}else if(el.tagName==='VIDEO'){prep(el);}
  }
  function scan(root){
    if(!root||!root.querySelectorAll){return;}
    root.querySelectorAll('video').forEach(function(v){
      if(v.__cv){return;}v.__cv=1;
      watch(v,v);
    });
    root.querySelectorAll('deferred-media').forEach(function(d){
      if(d.__cd){return;}d.__cd=1;
      var t=d.querySelector('template');
      if(t&&t.innerHTML.indexOf('<video')>-1){
        var host=d.closest('li')||d.parentElement||d;
        watch(host,d);
      }
    });
  }
  function start(){
    scan(document);
    if('MutationObserver' in window){
      new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.tagName==='VIDEO'){scan(n.parentNode);}else{scan(n);}}});});}).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
